export default __webpack_public_path__ + "static/media/Warglory Legguards.1325c666.jpg";